<template>
  <div id="editor-preview">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="isShowEditorPreview"
      width="600px"
      title="预览"
      top="2vh"
      @close="closePreviewDialog"
    >
      <div id="editor-preview-box"></div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'EditorPreview',
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('editor', {
      editorHtmlData: state => state.editorHtmlData,
      isShowEditorPreview: state => state.isShowEditorPreview,
    }),
  },
  watch: {
    isShowEditorPreview(val) {
      if (val) {
        this.setPreviewData()
      }
    },
  },
  methods: {
    ...mapMutations('editor', ['setShowPreviewStatus']),
    /*
     * 设置富文本框上的内容到容器上面
     * */
    setPreviewData() {
      this.$nextTick(() => {
        const box = document.getElementById('editor-preview-box')
        box.innerHTML = this.editorHtmlData
      })
    },
    /*
     * 关闭预览弹框
     * */
    closePreviewDialog() {
      this.setShowPreviewStatus(false)
    },
  },
}
</script>
<style scoped>
#editor-preview {
}
#editor-preview-box {
  width: 324px;
  min-height: 632px;
  margin: 0 auto;
  border-radius: 16px;
  border: 1px solid #cccccc;
  overflow-y: scroll;
  padding: 0 1em;
}

#editor-preview-box ::v-deep img {
  height: 200px;
  width: 100% !important;
}
#editor-preview-box ::v-deep table {
  width: 100%;
  border: 1px solid #cccccc;
  margin: 10px 0;
  box-sizing: border-box;
  border-collapse: collapse; /* 边框合并属性  */
}

#editor-preview-box ::v-deep table tr {
  padding: 0;
  margin: 0;
}
#editor-preview-box ::v-deep table th {
  border: 1px solid #cccccc;
  text-align: center;
  background-color: #f5f5f5;
  font-weight: 400;
  color: #222222;
  padding: 10px 5px;
  min-height: 30px;
}

#editor-preview-box ::v-deep table td {
  min-height: 40px;
  border: 1px solid #cccccc;
  padding: 10px 10px;
  font-weight: 400;
  color: #222222;
  border-collapse: separate;
  text-indent: initial;
  border-spacing: 2px;
}
#editor-preview-box ::v-deep table tr td:first-child {
  width: 100px;
}

#editor-preview-box ::v-deep .file_item {
  margin: 1em 0;
  padding: 1em 0.5em;
  border: 1px solid rgb(220, 220, 220);
  background: rgb(245, 245, 245);
  color: rgb(34, 34, 34);
  cursor: pointer;
}
#editor-preview-box ::v-deep .file_item:hover {
  border: 1px solid transparent !important;
  border-radius: 5px;
}
#editor-preview-box ::v-deep .file_item:active {
  color: #ffffff;
}
#editor-preview-box ::v-deep .file_item img {
  width: 24px !important;
  height: 24px;
}
::v-deep .area__container + p br {
	display: none !important;
}
</style>
